import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../api/api";

export default {
    getPengaturanLaporan: ({ commit }) => {
        return conn.get(api.laporan.getListData);
    },
    savePengaturanSumberDana: ({ commit }, { idAkun }) => {
        let posted = new FormData();
        idAkun.forEach((id) => {
            posted.append("id_akun[]", id);
        });

        return conn.post(api.laporan.updateSumberDana, posted, conn.contentType.form);
    },
    savePengaturanItemBiaya: ({ commit }, { idBiaya }) => {
        let posted = new FormData();
        idBiaya.forEach((id) => {
            posted.append("id_biaya[]", id);
        });

        return conn.post(api.laporan.updateItemBiaya, posted, conn.contentType.form);
    },
    setSumberDana: ({ commit }, payload) => {
        commit("setSumberDana", payload);
    },
    setItemBiaya: ({ commit }, payload) => {
        commit("setItemBiaya", payload);
    },
};
